module.exports = __webpack_public_path__ + "static/img/icon-40.e861943b.svg";